import type { MerchantCurrencyCode } from "./currency"

// Needs updating to copy app/portal code if ever needs to handle more currencies than GBP/EUR (since below code assumes 2 fractional digits in currency)
export const formatToCurrencyString = (
  price: number,
  currency: MerchantCurrencyCode,
  {
    compact = false,
    decimals = true,
    inputInMinorUnits = true,
  }: {
    compact?: boolean
    decimals?: boolean
    inputInMinorUnits?: boolean
  } = {}
): string => {
  const localeBcp47 = "en-GB"
  const amount = inputInMinorUnits ? price / 100 : price

  return new Intl.NumberFormat(localeBcp47, {
    style: "currency",
    currency,
    ...(compact && {
      notation: "compact",
      maximumFractionDigits: decimals ? 2 : 0,
    }),
  }).format(amount)
}
